import React from "react"
import Footer from "../organisation/footer/Footer";

import { Link } from "react-router-dom";

import { Button, Row, Col, Form, Card } from "react-bootstrap";

const Blog = () => {

  return (
    <div>
      <div style={{ overflow: 'hidden', backgroundColor: '#141332', color: 'white', height: '100vh', padding: '3%' }}>
      <Row>
              <Col>
                <h3 style={{color: "white", marginleft: '5%', textAlign: 'left', fontWeight: '900'}}>Lingo Loco</h3>
              </Col>
              <Col style={{textAlign: 'right'}}>
              <Link to="/levels"><Button
                      sx={{ mt: 1, mr: 1 }}
                      style={{borderColor:'white', color: 'white', marginLeft: '20px'}}
                      variant="outlined"
                    >
                      Dashboard
              </Button></Link>
              <Link to="/languages"><Button
                      variant="contained"
                      sx={{ mt: 1, mr: 1 }}
                      style={{backgroundImage:'linear-gradient(to left, #ED4CDD, #428BC1)', color: 'white', marginLeft: '40px'}}
              >Get started</Button></Link>
              </Col>
            </Row>
        <h6 style={{paddingTop: '5%'}}>We'll be posting articles surrounding language development and learning very shortly; watch this space!</h6>
      </div>
      <Footer/>  
    </div>
  );

};

export default Blog;